// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var inject = allVue.inject;
import { Button } from '@progress/kendo-vue-buttons';
import { Icon } from '@progress/kendo-vue-common';
import { moreHorizontalIcon } from '@progress/kendo-svg-icons';
/**
 * @hidden
 */
var ShowMoreItemsButtonVue2 = {
  name: 'KendoShowMoreItemsButton',
  props: {
    //  currentSlot: Object
  },
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    var kendoLocalizationService = inject('kendoLocalizationService', {});
    return {
      v3: v3,
      kendoLocalizationService: kendoLocalizationService
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this = this;
    var h = gh || createElement;
    return (
      // @ts-ignore  function children
      h(Button, {
        tabIndex: -1,
        attrs: this.v3 ? undefined : {
          tabIndex: -1
        },
        "class": "k-more-events",
        onClick: this.handleClick,
        on: this.v3 ? undefined : {
          "click": this.handleClick
        }
      }, this.v3 ? function () {
        return [h(Icon, {
          name: "more-horizontal",
          attrs: _this.v3 ? undefined : {
            name: "more-horizontal",
            icon: moreHorizontalIcon
          },
          icon: moreHorizontalIcon
        })];
      } : [h(Icon, {
        name: "more-horizontal",
        attrs: _this.v3 ? undefined : {
          name: "more-horizontal",
          icon: moreHorizontalIcon
        },
        icon: moreHorizontalIcon
      })])
    );
  },
  methods: {
    handleClick: function handleClick(event) {
      this.$emit('click', {
        target: {
          slot: this.currentSlot
        },
        event: event
      });
    }
  }
};
/**
 * @hidden
 */
var ShowMoreItemsButton = ShowMoreItemsButtonVue2;
export { ShowMoreItemsButton, ShowMoreItemsButtonVue2 };